import React from "react";
import { Link} from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";
import { MdDelete } from "react-icons/md";
import { FaEdit } from "react-icons/fa";
//import Modal from "react-modal";

function Products() {
  const [data, setData] = useState([]);
  const [number_of_products, setNumber_of_products] = useState(0);
  useEffect(() => {
    axios
      .get(process.env.REACT_APP_API_URL+"/api/products")
      .then((res) => {
        setData(res.data);
        setNumber_of_products(res.data.length);
        console.log(process.env.API_URL);
      })
      .catch((err) => {
        console.error(err);
      }); // This was missing
  }, []);

  const HandleClickedit = (pdtid) => {
    console.log(pdtid);
    window.location.href = `/products/EditForm/${pdtid}`;
  };
  const HandleClickdelete = (pdtid) => {
    console.log(pdtid);
    axios
      .delete(process.env.REACT_APP_API_URL+`/api/DeleteProduct/${pdtid}`)
      .then((res) => {
        console.log(res);
        console.log(res.data);
        window.location.href = "/products";
      })
      .catch((err) => {
        console.error(err);
      });
  };

  return (
    <>
      <div
        className="h-10 m-0 p-0 bg-slate-500 opacity-30"
        style={{ borderRadius: "4px" }}
      >
        <input
          type="text"
          className=" m-2"
          style={{ borderRadius: "4px" }}
          placeholder="Search"
        />
      </div>
      <section className="mx-auto w-full max-w-7xl px-4 py-4">
        <div className="flex flex-col space-y-4 md:flex-row md:items-center md:justify-between md:space-y-0">
          <div>
            <h2 className="text-lg font-semibold">Products</h2>
            <p className="mt-1 text-sm text-gray-700">
              {number_of_products} Products found
            </p>
          </div>
          <div>
            <Link to="./AddNewProducts">
              <button
                type="button"
                className="rounded-md bg-black px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-black/80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-black"
              >
                Add Product
              </button>
            </Link>
          </div>
        </div>
        <div className="mt-6 flex flex-col">
          <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
              <div className="overflow-hidden border border-gray-200 md:rounded-lg">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr className="divide-x divide-gray-200 productstr-data">
                      <th
                        scope="col"
                        className="w-1/12 px-2 py-3.5 text-left text-sm font-normal text-gray-500"
                      >
                        <span>Product</span>
                      </th>
                      <th
                        scope="col"
                        className="w-1/12 px-6 py-3.5 text-left text-sm font-normal text-gray-500"
                      >
                        Categery / Discription
                      </th>
                      <th
                        scope="col"
                        className="w-1/12 px-4 py-3.5 text-left text-sm font-normal text-gray-500"
                      >
                        Stock
                      </th>
                      <th
                        scope="col"
                        className=" w-1/12 px-4 py-3.5 text-left text-sm font-normal text-gray-500"
                      >
                        price/ MRP (Per KG)
                      </th>
                      <th
                        scope="col"
                        className="w-1/12 px-4 py-3.5 text-left text-sm font-normal text-gray-500"
                      >
                        Status
                      </th>
                      <th
                        scope="col"
                        className="w-1/12 px-4 py-3.5 text-left text-sm font-normal text-gray-500"
                      ></th>
                    </tr>
                  </thead>
                  {data.map((item, index) => {
                    return (
                      <tbody
                        className={index % 2 === 0 ? "bg-white" : "bg-gray-100"}
                        key={item.id}
                      >
                        <tr className="divide-x divide-gray-200 ">
                          <td className="whitespace-nowrap px-4 py-4">
                            <div className="flex items-center">
                              <div className="h-10 w-10 flex-shrink-0">
                                <img
                                  className="h-10 w-10 rounded-full object-cover"
                                  src={process.env.REACT_APP_API_URL+'/api/image/'+item.imgUrl}
                                  alt=""
                                />
                              </div>
                              <div className="ml-4">
                                <div className="text-sm font-medium text-gray-900">
                                  {item.name}
                                </div>
                                <div className="text-sm text-gray-500">
                                  {item.brand}
                                </div>
                              </div>
                            </div>
                          </td>
                          <td className="whitespace-nowrap px-12 py-4">
                            <div className="text-sm text-gray-900">
                              {item.category}
                            </div>
                            <div className="text-sm text-gray-500">
                              {item.description}
                            </div>
                          </td>
                          <td className="whitespace-nowrap px-4 py-4">
                            <span className="inline-flex rounded-full bg-green-100 px-2 text-xs font-semibold leading-5 text-green-800">
                              {item.stock} available
                            </span>
                          </td>
                          <td className="whitespace-nowrap px-4 py-4 text-sm text-gray-500">
                            {item.price} / {item.mrp}
                          </td>

                          <td className="whitespace-nowrap px-4 py-4 text-left text-sm font-medium">
                            {item.isActive ? (
                              <span className="inline-flex rounded-full bg-green-100 px-2 text-xs font-semibold leading-5 text-green-800">
                                Active
                              </span>
                            ) : (
                              <span className="inline-flex rounded-full bg-gray-300 px-2 text-xs font-semibold leading-5 text-gray-800">
                                Disabled
                              </span>
                            )}
                          </td>
                          <td className="whitespace-nowrap px-4 py-4 text-right text-sm font-medium">

                            
                            <button
                              onClick={() => HandleClickedit(item.id)}
                              className=" text-3xl text-blue-500"
                            >
                              <FaEdit/>
                            </button>
                            <button
                              onClick={() => HandleClickdelete(item.id)}
                              className=" text-3xl ml-2 text-red-600"
                            >
                              <MdDelete/>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    );
                  })}
                </table>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-4 w-full border-gray-300">
          <div className="mt-2 flex items-center justify-end">
            <div className="space-x-2">
              <button
                type="button"
                className="rounded-md bg-black px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-black/80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-black"
              >
                ← Previous
              </button>
              <button
                type="button"
                className="rounded-md bg-black px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-black/80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-black"
              >
                Next →
              </button>
            </div>
          </div>
        </div>
      </section>
      {/* <div className="grid place-items-center mr-10">
        <div className="pagination">
          <Link to="#">&laquo;</Link>
          <Link to="/products">1</Link>
          <Link to="#">2</Link>
          <Link to="#">3</Link>
          <Link to="#">4</Link>
          <Link to="#">5</Link>
          <Link to="#">6</Link>
          <Link to="#">&raquo;</Link>
        </div>
      </div> */}
    </>
  );
}

export default Products;
